import ArticleCard from '@/components/feature/ArticleCard';
import SectionHeading from '@/components/feature/SectionHeading';
import { getLatestArticles } from '@/utils/content';

export default function SpotlightSection() {
  const latest = getLatestArticles(4);
  const [main, ...rest] = latest;
  if (!main) return null;

  return (
    <section id="spotlight" className="mx-auto w-full scroll-mt-24 px-4 py-14 md:px-10 md:py-20">
      <SectionHeading
        kicker="TONIGHT · 今日爆点"
        title="今晚最值得看的那几条"
        description="编辑组按信息价值与讨论度挑选，每条都经过至少两次独立交叉核实。"
        morePath="/category/yule"
        moreLabel="更多首发"
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <ArticleCard article={main} variant="hero" />
        </div>
        <div className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-100 p-4">
          <h3 className="flex items-center gap-2 font-heading text-sm font-semibold text-foreground-100">
            <i className="ri-fire-line text-accent-400"></i>
            紧随其后的三条
          </h3>
          <div className="flex flex-col gap-1">
            {rest.map((item, index) => (
              <div
                key={item.id}
                className="flex gap-3 border-b border-background-200/70 pb-2 last:border-0"
              >
                <span className="font-heading text-2xl font-bold leading-none text-background-400">
                  {String(index + 2).padStart(2, '0')}
                </span>
                <div className="min-w-0 flex-1">
                  <ArticleCard article={item} variant="compact" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}